export const SETTINGS = {
  LEFT_NAV_WIDTH: 296,
  MUIBreakpointLg: 992,
  BREAKPOINTS_XL: 1024,
};
